import {
    RECEIVE_TAX_REGISTRATION,
    RECEIVE_TAX_REGISTRATION_AGREEMENT,
    REQUEST_TAX_REGISTRATION,
    RESET_TAX_REGISTRATION,
} from '@/actions'
import { updateOrAddItemsById } from '@/helpers'

export default (
    state = {
        isFetching: null,
        fetchSuccessful: null,
        agreements: [],
    },
    action
) => {
    const { type, data } = action

    switch (type) {
        case REQUEST_TAX_REGISTRATION:
            return { ...state, isFetching: true }

        case RECEIVE_TAX_REGISTRATION:
            return { ...state, ...data, isFetching: false }

        case RESET_TAX_REGISTRATION:
            return {
                isFetching: null,
                fetchSuccessful: true,
            }

        case RECEIVE_TAX_REGISTRATION_AGREEMENT: {
            const idKey = 'userId'
            const agreements = updateOrAddItemsById({
                currentItems: state.agreements,
                receivedItems: data.agreements,
                idKey,
            })
            return { ...state, agreements }
        }

        default:
            return state
    }
}
